import { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import CategoryGrid from './components/CategoryGrid';
import ProductGrid from './components/ProductGrid';
import Comparison from './components/Comparison';
import EditorsPicks from './components/EditorsPicks';
import BuyingGuides from './components/BuyingGuides';
import Footer from './components/Footer';
import AdUnit from '@/components/AdUnit';
import { useReveal } from '@/hooks/useReveal';

const LEADERBOARD_SLOT = import.meta.env.VITE_AD_SLOT_LEADERBOARD as string | undefined;

export default function Home() {
  useReveal();

  useEffect(() => {
    document.title = 'BuyWize - Expert Product Reviews, Comparisons & Buying Guides';
    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    setMeta('description', 'BuyWize helps you find the best products before you buy. Expert reviews, side-by-side product comparisons, and buying guides across electronics, gaming, home, kitchen and more.');
    setMeta('keywords', 'product reviews, buying guides, product comparisons, best products 2026, deals, affiliate shopping');
  }, []);

  return (
    <div className="min-h-screen bg-white text-ink-900 antialiased">
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-6">
          <AdUnit slot={LEADERBOARD_SLOT} label="Advertisement" style={{ minHeight: 90 }} />
        </div>
        <CategoryGrid />
        <ProductGrid />
        <Comparison />
        <EditorsPicks />
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-6">
          <AdUnit slot={LEADERBOARD_SLOT} label="Advertisement" style={{ minHeight: 90 }} />
        </div>
        <BuyingGuides />
      </main>
      <Footer />
    </div>
  );
}
